import React, { Fragment, useState, useEffect } from "react";
import { connect } from 'react-redux';
import { loginSuccess, setUser } from '../redux/actions/LoggedInAction';
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import toast from 'react-hot-toast';
import LocationResources from "../resources/LocationResources";
import UserResources from "../resources/UserResources";
import RotaResources from "../resources/RotaResources";
import Select from 'react-select';
import moment from "moment";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function validate(firstname, lastname, email, password, phone, address1, city, post_code, country, date_of_joining, date_of_birth, location_id, about, competencies, done_disclaimer, image) {
    return {
      firstname: firstname.length === 0,
      lastname: lastname.length === 0,
      email: email.length === 0,
      password: password.length === 0,
      phone: phone === 0,
      address1: address1.length === 0,
      city: city.length === 0,
      post_code: post_code.length === 0,
      country: country.length === 0,
      date_of_joining: date_of_joining.length === 0,
      date_of_birth: date_of_birth.length === 0,
      location_id: location_id.length === 0,
      about: about.length === 0,
      competencies: competencies.length === 0,
      done_disclaimer: !done_disclaimer,
      image: !image,
    };
  }

function MemberRegistration({loginSuccess, setUser}){
    const [locations, setLocations] = useState([])
    const [selectedJoiningDate, setSelectedJoiningDate] = useState(null); 
    const [rotaRoles, setRotaRoles] = useState([])
    const [selectedMediaRoles, setSelectedMediaRoles] = useState([]);
    const [birthday, setBirthday] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [isFortifyChecked, setIsFortifyChecked] = useState(false);
    const [isConnectChecked, setIsConnectChecked] = useState(false);
    const [isDisclaimerChecked, setIsDisclaimerChecked] = useState(false);
    const [isServeChecked, setIsServeChecked] = useState(false);
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        address1: '',
        city: '',
        post_code: '',
        phone: '',
        country: '',
        about: '',
        date_of_joining: null, // Assuming it's a Date object, initialize it appropriately
        date_of_birth: null, // Assuming it's a Date object, initialize it appropriately
        location_id: '',
        email: '',
        password: '',
      });

      const [formLoginData, setformLoginData] = useState({
        email: '',
        password: '',
      });
    
    const PUBLIC_KEY = process.env.REACT_APP_IMAGEKIT_PUBLIC_KEY || "public_Gs9BTDQd5hGInBhWGfz8dJCG9xg=";
    const IMAGEKITALBUM = "/Tlc_Media/Member_Pictures"
    const userImageAlbumId = '2hwMk0B' // imgur album id
    const locationResources = new LocationResources()
    const userResources = new UserResources()
    const rotaResources = new RotaResources()
    const today = new Date();
    

    const handleDateOfJoiningChange = (date) => {
        setSelectedJoiningDate(date);
    };

    const handleBirthdayChange = (date) => {
        setBirthday(date);
    };    

    const handleFortifyCheckboxChange = (event) => {
        setIsFortifyChecked(event.target.checked);
    };

    const handleConnectCheckboxChange = (event) => {
        setIsConnectChecked(event.target.checked);
    };

    const handleDisclaimerCheckboxChange = (event) => {
        setIsDisclaimerChecked(event.target.checked);
    };

    const handleServeCheckboxChange = (event) => {
        setIsServeChecked(event.target.checked);
    };

    const loadLocations = () => {
        return locationResources.get()
    }

    const loadRotaRoles = () => {
        return rotaResources.get_rota_roles()
    }

    // ToDO: renable this method to update state with date
    // const handleDateChange = (name, date) => {
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       [name]: date,
    //     }));
    //   };

    const handleCountrySelection = (selectedCountry) => {
        setFormData((prevData) => ({
          ...prevData,
          country: selectedCountry['value'],
        }));
      };
      
    const handleSelection = (selectedOptions) => {
        setFormData((prevData) => ({
          ...prevData,
          location_id: selectedOptions['value'],
        }));
      };

    const handleMediaSkillsSelection = (skills) => {
        setSelectedMediaRoles(skills)
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      const handleLoginInputChange = (e) => {
        const { name, value } = e.target;
        setformLoginData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImageFile(file);
        toast('Please Click Upload button to upload the selected image.');
      };  
   

    const uploadToImageKit = async () => {
        if (!imageFile) {
        toast.error('Please select a file.');
        return;
        }

        try {
            // 1. Get signature, token, expire from your backend
            const res = await userResources.get_admin_image_upload();

            if (res.error && res.error.length > 0) {
                toast.error("Image Server Upload failed. Contact Admin");
                return;
            }

            const { signature, expire, token } = res.body;
            // 2. Build form data with auth + file
            const form = new FormData();
            form.append("file", imageFile);
            form.append("fileName", formData.firstname || 'profile_pic');
            form.append("folder", IMAGEKITALBUM);
            form.append("useUniqueFileName", "true");

            // auth fields
            form.append("publicKey", PUBLIC_KEY);
            form.append("signature", signature);
            form.append("token", token);
            form.append("expire", expire);

            // 3. Upload to ImageKit
            const resp = await fetch("https://upload.imagekit.io/api/v1/files/upload", {
            method: "POST",
            body: form,
            });

            if (!resp.ok) throw new Error(await resp.text());
            const json = await resp.json();
            
            // 4. Store CDN URL
            setImageUrl(json.url);
            toast.success("Image Successfully uploaded. Now complete the rest of the form and submit.");

        } catch (error) {
            toast.error("Upload failed: " + error.message);
        }
};


    const uploadToImgur = async () => {
        if (!imageFile) {
            toast.error('Please select a file.');
            return;
        }

        try {
          const formData = new FormData();
          formData.append('image', imageFile);
          formData.append('album', userImageAlbumId);
    
          const response = await fetch('https://api.imgur.com/3/image', {
            method: 'POST',
            headers: {
              Authorization: `Bearer ` + process.env.REACT_APP_Bearer_Token.toString(), 
            },
            body: formData,
          });
    
          const data = await response.json();
    
          if (data.success) {
            setImageUrl(data.data.link);   
            //addToMemberAlbum(data.data.id)         
            toast.success('Image Successfully uploaded. Now complete the rest of the form and submit.');
          } else {
            toast.error('Error Uploading Image, please try again');
          }
        } catch (error) {
          toast.error('Error Uploading Image, please try again');
        }
      };   
      
    const canBeSubmitted = (dataToSubmit) => {
        const errors = validate(dataToSubmit['firstname'], dataToSubmit['lastname'], dataToSubmit['email'], dataToSubmit['password'],  dataToSubmit['phone'], dataToSubmit['address1'], 
        dataToSubmit['city'], dataToSubmit['post_code'], dataToSubmit['country'],dataToSubmit['date_of_joining'],dataToSubmit['date_of_birth'],dataToSubmit['location_id'],
        dataToSubmit['about'], dataToSubmit['competencies'], dataToSubmit['done_disclaimer'], dataToSubmit['image']);
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return !isDisabled;
    }

    const passwordQualityCheck = (password) => {
        // At least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character
        const passwordRegex = /^(?=.*[A-Z])(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/;
        return passwordRegex.test(password);
    }
    

    const handleLoginSubmit = (e) => {
        e.preventDefault();   
        if (formLoginData.email.length === 0 || formLoginData.password.length === 0){
            toast.error("Enter username and password")
            return
        }
        userResources.user_post_login(formLoginData).then(res => {
            if (res.error.length < 1) {
                loginSuccess();                
                localStorage.setItem('access_token', res['body']['access_token']);
                localStorage.setItem('refresh_token', res['body']['refresh_token']);
                setUser(res['body'])
                toast.success("Successfully logged in.")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/';
                  }, 200);
            } else {
                toast.error("Login Failed, please check details entered.")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });

       
      };

    const handleSubmit = (e) => {
        e.preventDefault();
        // confirm dialog before submission
        if(!window.confirm("Are you sure you want to submit your registration?")){ 
            return;
        }
        let submitFormData = formData
        // ToDo: Fix this hack: get all data from state
        let media_roles =[]        
        selectedMediaRoles.map((role) => (
            media_roles.push(role['value'])
        ))
        const mediaRoles = media_roles.join(', ')
        submitFormData['competencies'] = mediaRoles
        submitFormData['image'] = imageUrl
        submitFormData['date_of_joining'] = moment( selectedJoiningDate ).format('YYYY-MM-DD HH:mm:ss') 
        submitFormData['date_of_birth'] = moment( birthday ).format('YYYY-MM-DD HH:mm:ss') 
        submitFormData['done_connect'] =  isConnectChecked       
        submitFormData['done_fortify'] = isFortifyChecked 
        submitFormData['done_serve'] = isServeChecked
        submitFormData['done_disclaimer'] = isDisclaimerChecked        

        if (!canBeSubmitted(submitFormData)){
            toast.error("Remember to fill out the mandatory fields, click upload on the image, and check the relevant boxes")
            return
        }

        if (!passwordQualityCheck(submitFormData['password'])) {
            toast.error("Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.");
            return;
        }


        userResources.admin_post(submitFormData).then(res => {
            if (res.error.length < 1) {
                toast.success("Thanks for registering! Your Profile is pending approval")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/about';
                  }, 200);
            }else if(res.error === 'Email already in use') {
                toast.error("Registration failed, Email Already in Use.")
            }
            else {
                toast.error("Registration Failed, please check details entered.")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });

       
      };

    useEffect(() => {     
        loadLocations().then(response => {
            setLocations(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        loadRotaRoles().then(response => {
            setRotaRoles(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

    }, []);
    
    let mediaLocations = []  
    locations.map((loc, index) => (
        mediaLocations.push({value: loc['id'], label: loc['name'] })
    ))

    let mediaRoles = []
    rotaRoles
        .filter(rotaRole => rotaRole['is_core_role'] === true || rotaRole['is_core_role'] === 1 || rotaRole['is_core_role'] === 'true')
        .map((rotaRole) => (
            mediaRoles.push({value: rotaRole['name'], label: rotaRole['name'] })
        ))
    mediaRoles.push({value: 'Photography', label: 'Photography' })
    mediaRoles.push({value: 'Camera close up', label: 'Camera close up' })
    mediaRoles.push({value: 'Roaming Camera', label: 'Roaming Camera' })
    mediaRoles = mediaRoles.filter(role => role.value !== 'Camera 1');
    mediaRoles = mediaRoles.filter(role => role.value !== 'Roam 1');
    mediaRoles = mediaRoles.filter(role => role.value !== 'Roam 2');

    let countries= []
    countries.push({value: 'United Kingdom', label: 'United Kingdom' })
    countries.push({value: 'Nigeria', label: 'Nigeria' })

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            {/* <div className="page-banner parallax" style={{backgroundImage: "url(assets/images/testjpeg1280.jpg)"}}> */}
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>Enter Your Details</strong></h1>
                        </div>
                    </div>
                </div>
            </div>

            {/* <!-- Main Content --> */}
            <div id="main-container">
                <div className="content">
                <div className="container" id="openings">
                        <div className="col-md-12">
                            <div className="col-md-10 col-sm-10 mx-auto">
                                <div style={{marginBottom: '40px'}}>
                                    <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', overflow: 'hidden'}}>
                                        <div style={{backgroundColor: '#003165', padding: '16px 24px'}}>
                                            <h2 style={{color: '#ffa800', margin: 0, fontSize: 'clamp(18px, 4.5vw, 22px)'}}>Member Login</h2>
                                        </div>
                                        <div style={{padding: '24px'}}>
                                            <form onSubmit={handleLoginSubmit}>
                                                <div className="row">
                                                    <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                        <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Email<span style={{color:"#d80000"}}>*</span></label>
                                                        <input type="email" className="form-control"
                                                            name="email"
                                                            value={formLoginData.email}
                                                            onChange={handleLoginInputChange}
                                                            style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                        />
                                                    </div>
                                                    <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                        <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Password<span style={{color:"#d80000"}}>*</span></label>
                                                        <input type="password" className="form-control"
                                                            name="password"
                                                            value={formLoginData.password}
                                                            onChange={handleLoginInputChange}
                                                            style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{marginTop: '20px'}}>
                                                    <input style={{backgroundColor:"#8ccd80", color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', padding: '10px 30px', border: 'none', borderRadius: '6px', cursor: 'pointer'}} type="submit" className="btn btn-primary" value="Login"/>
                                                </div>
                                                <div style={{marginTop: '16px'}}>
                                                    <a style={{color:"#ffa800", fontSize: 'clamp(13px, 3.5vw, 14px)', fontWeight: 'bold'}} href="/passwordresetrequest">Forgot Password?</a>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container" id="openings">
                        <div className="col-md-12">
                            <div className="col-md-10 col-sm-10 mx-auto">
                                <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', overflow: 'hidden'}}>
                                    <div style={{backgroundColor: '#003165', padding: '16px 24px'}}>
                                        <h2 style={{color: '#ffa800', margin: 0, fontSize: 'clamp(18px, 4.5vw, 22px)'}}>Member Registration</h2>
                                    </div>
                                    <div style={{padding: '24px'}}>
                                        <form onSubmit={handleSubmit}>
                                            <div style={{backgroundColor: '#fff3cd', borderRadius: '8px', padding: '12px 16px', marginBottom: '24px'}}>
                                                <p style={{color: '#856404', margin: 0, fontSize: 'clamp(13px, 3.5vw, 14px)', fontWeight: 'bold'}}>Essential you provide requested details</p>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>First Name<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="text" className="form-control"
                                                        name="firstname"
                                                        value={formData.firstname}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Last Name<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="text" className="form-control"
                                                        name="lastname"
                                                        value={formData.lastname}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Address<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="text" className="form-control"
                                                        name="address1"
                                                        value={formData.address1}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>City<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="text" className="form-control"
                                                        name="city"
                                                        value={formData.city}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Postcode<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="text" className="form-control"
                                                        name="post_code"
                                                        value={formData.post_code}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Phone Number<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="number" className="form-control"
                                                        name="phone"
                                                        value={formData.phone}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Country<span style={{color:"#d80000"}}>*</span></label>
                                                    <Select
                                                        name='country-drpdwn'
                                                        id="country-drpdwn"
                                                        classNamePrefix='select-css-tag'
                                                        onChange={handleCountrySelection}
                                                        options={countries}
                                                        placeholder="Choose one"
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Media Competencies<span style={{color:"#d80000"}}>*</span></label>
                                                    <Select
                                                        name='media-skills'
                                                        id="media-skills"
                                                        classNamePrefix='select-css-tag'
                                                        isMulti
                                                        onChange={handleMediaSkillsSelection}
                                                        options={mediaRoles}
                                                        placeholder="Select all that apply"
                                                    />
                                                </div>
                                            </div>

                                            <div style={{marginBottom: '20px'}}>
                                                <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>About You<span style={{color:"#d80000"}}>*</span></label>
                                                <textarea cols="4" rows="4" id="message" name="about" value={formData.about}
                                                    onChange={handleInputChange} className="form-control input-lg"
                                                    placeholder="Short Bio - Why you joined media, Career, Skillset, interests etc"
                                                    style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                />
                                            </div>

                                            <div style={{marginBottom: '20px'}}>
                                                <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '8px', display: 'block'}}>Church Progression<span style={{color:"#d80000"}}>*</span></label>
                                                <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
                                                    <div
                                                        onClick={handleConnectCheckboxChange}
                                                        style={{
                                                            backgroundColor: isConnectChecked ? '#e8f8f0' : '#f8f9fa',
                                                            border: `2px solid ${isConnectChecked ? '#35ab7c' : '#ccc'}`,
                                                            borderRadius: '8px',
                                                            padding: '10px 16px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            flex: '1 1 120px',
                                                            minWidth: '120px'
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isConnectChecked}
                                                            onChange={handleConnectCheckboxChange}
                                                            style={{accentColor: '#35ab7c', width: '16px', height: '16px', cursor: 'pointer'}}
                                                        />
                                                        <span style={{fontSize: 'clamp(13px, 3.5vw, 14px)', fontWeight: 'bold', color: isConnectChecked ? '#35ab7c' : '#666'}}>Connect</span>
                                                    </div>
                                                    <div
                                                        onClick={handleFortifyCheckboxChange}
                                                        style={{
                                                            backgroundColor: isFortifyChecked ? '#e8f8f0' : '#f8f9fa',
                                                            border: `2px solid ${isFortifyChecked ? '#35ab7c' : '#ccc'}`,
                                                            borderRadius: '8px',
                                                            padding: '10px 16px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            flex: '1 1 120px',
                                                            minWidth: '120px'
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isFortifyChecked}
                                                            onChange={handleFortifyCheckboxChange}
                                                            style={{accentColor: '#35ab7c', width: '16px', height: '16px', cursor: 'pointer'}}
                                                        />
                                                        <span style={{fontSize: 'clamp(13px, 3.5vw, 14px)', fontWeight: 'bold', color: isFortifyChecked ? '#35ab7c' : '#666'}}>Fortify</span>
                                                    </div>
                                                    <div
                                                        onClick={handleServeCheckboxChange}
                                                        style={{
                                                            backgroundColor: isServeChecked ? '#e8f8f0' : '#f8f9fa',
                                                            border: `2px solid ${isServeChecked ? '#35ab7c' : '#ccc'}`,
                                                            borderRadius: '8px',
                                                            padding: '10px 16px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            flex: '1 1 120px',
                                                            minWidth: '120px'
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isServeChecked}
                                                            onChange={handleServeCheckboxChange}
                                                            style={{accentColor: '#35ab7c', width: '16px', height: '16px', cursor: 'pointer'}}
                                                        />
                                                        <span style={{fontSize: 'clamp(13px, 3.5vw, 14px)', fontWeight: 'bold', color: isServeChecked ? '#35ab7c' : '#666'}}>Serve</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Date of Joining Production Team<span style={{color:"#d80000"}}>*</span></label>
                                                    <DatePicker
                                                        name="dateOfJoining"
                                                        placeholderText="When you joined the team"
                                                        value={selectedJoiningDate}
                                                        onChange={handleDateOfJoiningChange}
                                                        maxDate={today}
                                                        dateFormat="yyyy-MM-dd"
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Birthday (Choose any Year)<span style={{color:"#d80000"}}>*</span></label>
                                                    <DatePicker
                                                        name="birthday"
                                                        placeholderText="Pick Date"
                                                        value={birthday}
                                                        onChange={handleBirthdayChange}
                                                        maxDate={today}
                                                        dateFormat="yyyy-MM-dd"
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Primary Service Location<span style={{color:"#d80000"}}>*</span></label>
                                                    <Select
                                                        name='requirements'
                                                        id="requirements"
                                                        classNamePrefix='select-css-tag'
                                                        onChange={handleSelection}
                                                        options={mediaLocations}
                                                        placeholder="Locations"
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Face Card - Add Image (200×200)<span style={{color:"#d80000"}}>*</span></label>
                                                    <input
                                                        className="form-control"
                                                        type="file"
                                                        name="productImages"
                                                        id="images"
                                                        onChange={handleImageChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '8px'}}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={uploadToImageKit}
                                                        style={{backgroundColor:'#8ccd80', color: '#003165', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    >
                                                        Upload Image
                                                    </button>
                                                </div>
                                            </div>

                                            {imageUrl && (
                                                <div style={{marginBottom: '20px', textAlign: 'center'}}>
                                                    <p style={{color: '#35ab7c', fontSize: 'clamp(13px, 3.5vw, 14px)', fontWeight: 'bold', marginBottom: '8px'}}>Image uploaded successfully!</p>
                                                    <div style={{width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', margin: '0 auto', border: '3px solid #ffa800'}}>
                                                        <img src={imageUrl} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt="Preview"/>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="row">
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Email<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="email" className="form-control"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Password<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="password" className="form-control"
                                                        name="password"
                                                        value={formData.password}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{backgroundColor: '#fff3cd', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px'}}>
                                                <p style={{color: '#856404', margin: 0, fontSize: 'clamp(12px, 3.2vw, 13px)', fontWeight: 'bold'}}>⚠ Please ensure you clicked "Upload Image" before submitting the form</p>
                                            </div>

                                            <div style={{marginBottom: '20px'}}>
                                                <div
                                                    onClick={handleDisclaimerCheckboxChange}
                                                    style={{
                                                        backgroundColor: '#f8f9fa',
                                                        border: `2px solid ${isDisclaimerChecked ? '#35ab7c' : '#ccc'}`,
                                                        borderRadius: '8px',
                                                        padding: '12px 16px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        gap: '10px'
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={isDisclaimerChecked}
                                                        onChange={handleDisclaimerCheckboxChange}
                                                        style={{accentColor: '#35ab7c', width: '18px', height: '18px', cursor: 'pointer', marginTop: '2px', flexShrink: 0}}
                                                    />
                                                    <label style={{color: '#003165', fontSize: 'clamp(13px, 3.5vw, 14px)', cursor: 'pointer', margin: 0}}>
                                                        I agree to my data being held by Liberty Church Media for the purpose of effective management of the Media team<span style={{color:"#d80000"}}>*</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div style={{marginTop: '24px'}}>
                                                <input style={{backgroundColor:"#8ccd80", color: '#003165', fontWeight: 'bold', fontSize: 'clamp(14px, 3.8vw, 16px)', padding: '12px 40px', border: 'none', borderRadius: '6px', cursor: 'pointer'}} type="submit" className="btn btn-primary" value="Submit Registration"/>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <Footer/>     
        </Fragment>
    )
}

const mapDispatchToProps = {
    loginSuccess,
    setUser,
};

export default connect(null, mapDispatchToProps)(MemberRegistration);
